module.exports = __webpack_public_path__ + "img/img4.26397578.svg";